import { cx } from '@libs/classnames';

import styles from './SimpleToggle.module.css';

type Props = {
  className?: string;
  size?: '16x10';
  color?: 'club' | 'green' | 'blue';
  checked?: boolean;
  onChange?: (checked: boolean) => void;
};

export function SimpleToggle({
  className,
  size = '16x10',
  checked,
  onChange,
  color = 'club',
}: Props) {
  return (
    <label className={cx(styles.toggle, styles[`is_${size}`], styles[`is_${color}`], className)}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange?.(e.target.checked)} />
      <span className={styles.slider}></span>
    </label>
  );
}
